import type { Cellule, Ton } from "./ui.tsx";

/** Données de démonstration des listes du back-office, ancrées sur les écrans WordPress existants. */

const t = (texte: string): Cellule => ({ type: "texte", texte });
const lien = (texte: string): Cellule => ({ type: "lien", texte });
const muet = (texte: string): Cellule => ({ type: "muet", texte });
const badge = (texte: string, ton: Ton): Cellule => ({ type: "badge", texte, ton });
const btn = (texte: string): Cellule => ({ type: "bouton", texte });

export interface ListeConfig {
  colonnes: readonly string[];
  lignes: readonly (readonly Cellule[])[];
  hint?: string;
  ajouter?: string;
  exportable?: boolean;
  mode?: "normal" | "vide" | "erreur";
}

export const LISTES: Record<string, ListeConfig> = {
  "/admin/salons": {
    ajouter: "Ajouter un salon",
    colonnes: ["Nom", "Année", "Ville", "Dates", "Exposants", "Stagiaires", "Date de création"],
    lignes: [
      [lien("HOPITECH 2027"), t("2027"), t("Arles"), t("24 / 25 / 26 mars 2027"), t("19"), t("0"), muet("27/04/2026")],
      [lien("HOPITECH 2026"), t("2026"), t("Le Touquet-Paris-Plage"), t("25 / 26 / 27 mars 2026"), t("68"), t("80"), muet("13/06/2025")],
      [lien("HOPITECH 2025"), t("2025"), t("La Rochelle"), t("26 › 28 mars 2025"), t("74"), t("120"), muet("04/09/2024")],
      [lien("HOPITECH 2024"), t("2024"), t("Beaune"), t("27 › 29 mars 2024"), t("67"), t("91"), muet("01/02/2023")],
      [lien("HOPITECH 2023"), t("2023"), t("Toulouse"), muet("—"), muet("N/C"), muet("N/C"), muet("01/02/2022")],
    ],
  },
  "/admin/exposants": {
    ajouter: "Ajouter un exposant",
    hint: "L'attribution des emplacements est un geste à intention commerciale (placer des partenaires, séparer des concurrents), pas une simple saisie.",
    colonnes: ["Enseigne", "Contact", "Stand souhaité", "Emplacement", "Sellsy", "Paiement"],
    lignes: [
      [lien("DELABIE"), t("Clémence Turpin"), t("Stand 9 m²"), badge("A-14", "accent"), badge("Facturé", "ok"), badge("Réglé", "ok")],
      [lien("IDEX"), t("Clément Famié"), t("Stand 12 m²"), badge("B-03", "accent"), badge("Facturé", "ok"), badge("Attendu", "warn")],
      [lien("APAVE"), t("Éric Martin"), t("Stand 6 m²"), badge("En attente", "muted"), badge("En cours", "warn"), badge("Attendu", "warn")],
      [lien("ADOPALE"), t("Luc Landman"), t("Stand 9 m²"), badge("A-07", "accent"), badge("Facturé", "ok"), badge("Réglé", "ok")],
    ],
  },
  "/admin/stagiaires": {
    ajouter: "Ajouter un stagiaire",
    colonnes: ["Nom", "Téléphone", "Email", "Ville", "Dernier salon", "Commande de formation", "Badges", "Sellsy", "Inscription"],
    lignes: [
      [lien("BENOIT Pascal"), t("+33 6 19 51 45 90"), muet("benoit.p@chu-toulouse.fr"), t("Toulouse"), t("2026"), badge("Réglée", "ok"), btn("Badge"), badge("Facturé", "ok"), muet("07/03/2025")],
      [lien("HOULIEZ David"), t("+33 3 21 89 69 03"), muet("dhouliez@ch-montreuil.fr"), t("Rang-du-Fliers"), t("2026"), badge("En cours", "warn"), btn("Badge"), badge("En cours", "warn"), muet("18/03/2025")],
    ],
  },
  "/admin/intervenants": {
    ajouter: "Ajouter un intervenant",
    colonnes: ["Nom", "Email", "Téléphone", "Organisation", "Ville", "Dernier salon", "Badges", "Inscription"],
    lignes: [
      [lien("CHALLET Kévin"), muet("kevin.challet@orriap.fr"), t("+33 6 50 27 37 36"), t("ORRIAP"), t("Le Pallet"), t("2026"), btn("Télécharger"), muet("06/03/2026")],
      [lien("DENIS Laurent"), muet("laurent.denis@ght85.fr"), muet("—"), t("MAPES"), muet("—"), t("2026"), btn("Télécharger"), muet("06/03/2026")],
      [lien("MARTIN Éric"), muet("eric.martin@apave.com"), muet("—"), t("APAVE"), t("Marseille"), t("2026"), btn("Télécharger"), muet("06/03/2026")],
    ],
  },
  "/admin/organisateurs": {
    ajouter: "Ajouter un organisateur",
    colonnes: ["Nom", "Email", "Téléphone", "Organisation", "Ville", "Dernier salon", "Badges", "Inscription"],
    lignes: [
      [lien("BENOIT Pascal"), muet("benoit.p@chu-toulouse.fr"), t("+33 6 19 51 45 90"), t("CHU Toulouse — Purpan"), t("Toulouse"), t("2026"), btn("Télécharger"), muet("07/03/2025")],
      [lien("LEFEBVRE Valéry"), muet("valery.lefebvre@aphp.fr"), muet("—"), t("APHP — CHU Bicêtre"), t("Le Kremlin-Bicêtre"), t("2026"), btn("Télécharger"), muet("07/03/2025")],
      [lien("NIORT Jean-Noël"), muet("jean-noel.niort@ch-…"), muet("—"), t("Centre de santé mentale"), t("Ste-Gemmes"), t("2026"), btn("Télécharger"), muet("07/03/2025")],
    ],
  },
  "/admin/visiteurs": {
    ajouter: "Ajouter un visiteur",
    colonnes: ["Nom", "Type", "Email", "Ville", "Dernier salon", "Badges", "Sellsy", "Inscription"],
    lignes: [
      [lien("ADAMCZYK Francis"), badge("Visiteur Salon", "accent"), muet("fadamczyk@distech.com"), t("Brignais"), t("2026"), btn("Badge"), badge("Facturé", "ok"), muet("27/03/2026")],
      [lien("Baciu Catherine"), badge("Invité Exposant", "muted"), muet("contact@studio-echo.com"), t("Paris"), t("2026"), btn("Badge"), badge("En cours", "warn"), muet("17/03/2026")],
      [lien("BRAY Jonathan"), badge("Visiteur Salon", "accent"), muet("jonathan.bray@comlink.fr"), t("Carvin"), t("2026"), btn("Badge"), badge("Facturé", "ok"), muet("26/03/2026")],
    ],
  },
  "/admin/invites": {
    exportable: true,
    hint: "Vue filtrée des visiteurs sur le type « Invité Exposant », avec le rattachement à l'exposant invitant.",
    colonnes: ["Nom", "Invité par", "Email", "Ville", "Badges", "Inscription"],
    lignes: [
      [lien("Baciu Catherine"), badge("DELABIE", "accent"), muet("contact@studio-echo.com"), t("Paris"), btn("Badge"), muet("17/03/2026")],
      [lien("Botzung Frédéric"), badge("ENGIE", "accent"), muet("frederic.botzung@engie.com"), t("Urimenil"), btn("Badge"), muet("03/03/2026")],
    ],
  },
  "/admin/inscriptions": {
    ajouter: "Créer une inscription complémentaire",
    colonnes: ["Salon", "Type de réservation", "Nom", "Description"],
    lignes: [
      [t("HOPITECH 2027"), badge("Forum de l'innovation", "accent"), t("Tech'Innov"), muet("Espace dédié aux jeunes pousses de l'ingénierie hospitalière.")],
    ],
  },
  "/admin/ateliers": {
    ajouter: "Ajouter un atelier",
    colonnes: ["Nom de l'atelier", "Intervenant", "Lieu", "Date", "Heure", "Durée", "Catégories"],
    lignes: [
      [lien("Maintenance biomédicale connectée"), t("K. Challet"), t("Salle A"), muet("24/03/2027"), t("10:00"), t("90 min"), badge("Biomédical", "muted")],
      [lien("Sobriété énergétique à l'hôpital"), t("É. Martin"), t("Salle B"), muet("25/03/2027"), t("14:00"), t("60 min"), badge("Énergie", "muted")],
    ],
  },
  "/admin/etablissements": {
    exportable: false,
    hint: "Référentiel national alimenté par une source publique. La recherche pré-remplit les formulaires ; une correction manuelle reste possible.",
    colonnes: ["Établissement", "Ville", "Code postal", "Type"],
    lignes: [
      [lien("CHU de Toulouse — Purpan"), t("Toulouse"), t("31059"), badge("CHU", "accent")],
      [lien("CH de Montreuil-sur-Mer"), t("Rang-du-Fliers"), t("62180"), badge("CH", "muted")],
      [lien("APHP — CHU Bicêtre"), t("Le Kremlin-Bicêtre"), t("94270"), badge("CHU", "accent")],
    ],
  },
  "/admin/journal": {
    exportable: true,
    hint: "Journal append-only : il ne se réécrit pas, une correction est un nouvel événement.",
    colonnes: ["Horodatage", "Type", "Acteur", "Sujet", "Détail"],
    lignes: [
      [muet("28/07 16:10"), badge("reservation_validee", "ok"), t("clemence"), t("RES-12-C303C5FA1F"), muet("commande Sellsy émise")],
      [muet("28/07 15:42"), badge("connexion", "muted"), t("augustin"), t("—"), muet("depuis 2 appareils")],
      [muet("27/07 11:20"), badge("reprise_manuelle", "warn"), t("bureau"), t("RES-11-9F2A…"), muet("TVA corrigée à la main")],
      [muet("26/07 09:03"), badge("revocation", "danger"), t("augustin"), t("session  4f2…"), muet("perte d'appareil")],
    ],
  },
  "/admin/catalogue": {
    exportable: false,
    ajouter: undefined,
    hint: "La vérité tarifaire vient de Sellsy. Maquetté en lecture : dépôt, listage, aucune écriture ici.",
    colonnes: ["Référence", "Famille", "Libellé", "HT", "TVA", "Disponibilité"],
    lignes: [
      [t("STAND-6M2"), badge("stand", "accent"), t("Stand nu 6 m²"), t("1 200,00 €"), t("20 %"), badge("Disponible", "ok")],
      [t("STAND-9M2"), badge("stand", "accent"), t("Stand nu 9 m²"), t("1 650,00 €"), t("20 %"), badge("Disponible", "ok")],
      [t("STAND-12M2"), badge("stand", "accent"), t("Stand nu 12 m²"), t("2 100,00 €"), t("20 %"), badge("Limité", "warn")],
      [t("PUB-A4"), badge("publicité", "muted"), t("Encart A4 magazine"), t("500,00 €"), t("20 %"), badge("Disponible", "ok")],
      [t("REPAS-EXPO"), badge("repas", "muted"), t("Repas exposant"), t("28,00 €"), t("10 %"), badge("Disponible", "ok")],
    ],
  },
};
